import { useDebounce, useLocalStorage } from 'usehooks-ts';
import { useState } from 'react';
import api from 'lib/trpcClient';

export type LatestSearch = {
  category: 'companies';
  name: string;
  logo: string;
  url: string;
};

export enum GlobalSearchState {
  Loading = 'loading',
  Empty = 'empty',
  Results = 'results',
  LatestSearched = 'latestSearched',
}

export default function useGlobalSearch(vehicleId: string | null) {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 300);
  const [latestSearched, setLatestSearched] = useLocalStorage<
    Array<LatestSearch>
  >(`latest-global-search-${vehicleId}`, []);

  const { data, isFetching } = api.globalSearch.search.useQuery(
    {
      searchQuery: debouncedQuery,
      vehicleId: vehicleId ?? '',
    },
    { enabled: !!debouncedQuery.length && !!vehicleId },
  );

  const state = isFetching
    ? GlobalSearchState.Loading
    : data && debouncedQuery.length > 0
    ? GlobalSearchState.Results
    : latestSearched.length > 0
    ? GlobalSearchState.LatestSearched
    : GlobalSearchState.Empty;

  return {
    state,
    query,
    setQuery,
    debouncedQuery,
    latestSearched,
    setLatestSearched,
    results: data,
  };
}
